export default "__VITE_ASSET__Bs3xGWtX__"